export default __webpack_public_path__ + "static/media/perk-gold-hand.99a161c3.png";